import axios from 'axios';
import cookie from 'react-cookies';
import API from '../../settings/api';

const disableLogout = false;

export async function In( store, e, p, redirect, showError ) {

  try {

    const { status, data } = await axios.post( API.sign.in, { email: e, password: p } );

    console.log(`signIn data:`, data);

    if ( status === 200 ) {

      if ( data.success ) {

        cookie.save('token', data.token, { path: '/' });
        redirect();
        
      } else {

        throw( data.error );

      }

    } else {

      throw('Нет соединения с сервером');

    }

  } catch ( err ) {

    console.error( err );
    showError( err );

  }
  
}

export async function Check( store, token, reload = () => {} ) {

  try {

    store.setState({ isDataLoaded: false });

    const { status, data } = await axios.post( API.sign.check, { token } );

    console.log(`check data: ${status}`, data);

    if ( status === 200 && data.success ) {

      const { 

        subscribe: {

          remainingDays,
          dateEnd


        },

        user: {

          email,
          company_name,
          fio,
          phone

        },

        parsing = { 
          
          folder: null, 
          date: null,
          nextParsing: null,
        
        }

      } = data;

      let newState = {

        isDataLoaded: true,
        
        subscribeRemainingDays: remainingDays,
        subscribeDateEnd: dateEnd,

        parsingFolder: parsing?.folder || null,
        parsingDate: parsing?.date || null,
        parsingNextTime: parsing?.nextParsing || null,

        user: {

          email,
          company_name,
          fio,
          phone

        }
      
      }

      store.setState( newState );

      setTimeout(() => {

        reload()
        console.log('reload')

      }, 500);
      
      return true;
      
    } else {

      throw('');

    }

  } catch ( err ) {

    console.error(`Check:`, err);
    store.actions.sign.Out();
    return false;    

  }
  
}

export async function Out() {

  try {

    if ( disableLogout ) { alert('LogOut'); return;}

    cookie.remove(`token`);
    window.location = "/auth";

  } catch(err) {

    console.error( err );

  }

}